import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/styles/global.scss";

const app = createApp(App);
app.use(router);
app.use(
  AOS.init({
    duration: 1000,
    easing: "ease-in-out",
    once: false,
    mirror: true,
    offset: 50,
  })
);

app.mount("#app");
